<!--  LegalizationDocuments -->
<div class="header">
  <h2>{{ 'Legalization.LegalizationDocuments' | translate }}</h2>
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openDocumentLegalizationForCoordinator(null)">
      {{ 'WL-AddDocument' | translate }}
    </button>
  </div>
</div>
<div class="table-wrapper">
  <table class="five-cols">
    <thead>
      <tr>
        <th class="column-documenttype">{{ 'Legalization.DocumentType' | translate }}</th>
        <th class="column-description">{{ 'Legalization.Description' | translate }}</th>
        <th class="column-createdon">{{ 'Legalization.CreatedOn' | translate }}</th>
        <th class="column-startdate">{{ 'Legalization.StartDate' | translate }}</th>
        <th class="column-enddate">{{ 'Legalization.EndDate' | translate }}</th>
        <th class="column-actions">{{ 'Actions' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (legalizationDocument of legalizationDocuments | filter : legalizationDocumentsFilter; track legalizationDocument) {
        <tr>
          <td class="column-documenttype">{{ legalizationDocument?.Name }}</td>
          <td class="column-description">{{ legalizationDocument?.Description }}</td>
          <td class="column-createdon">{{ legalizationDocument?.CreatedOn ? (legalizationDocument?.CreatedOn | date : 'yyyy-MM-dd') : '' }}</td>
          <td class="column-startdate">{{ legalizationDocument?.StartDate ? (legalizationDocument?.StartDate | date : 'yyyy-MM-dd') : '' }}</td>
          <td class="column-enddate">{{ legalizationDocument?.EndDate ? (legalizationDocument?.EndDate | date : 'yyyy-MM-dd') : '' }}</td>
          <td class="column-actions">
            @for (file of legalizationDocument.Files; track file) {
              <div class="file">
                <a href="javascript:void(0)" (click)="showFile(file)">{{ file.Name ?? file.OriginalName }}</a>
                @if (workerId) {
                  <button mat-icon-button color="primary" (click)="downloadFile(file.Id, file.Name)">
                    <mat-icon>download</mat-icon>
                  </button>
                }
                @if (canDeleteUnsavedLegalizationDocuments) {
                  <button mat-icon-button color="primary" (click)="deleteUnsavedFile(legalizationDocument, file)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
